import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { Dialog, FlatButton, IconButton, IconMenu, MenuItem } from 'material-ui';
import { Link } from 'react-router-dom';
import MoreVertIcon from 'material-ui/svg-icons/navigation/more-vert';
import { grey400 } from 'material-ui/styles/colors';
import { fetchApp } from '../../store/apps/actions';
import {
    deleteRoadBookConfigurations,
    getRoadBookConfigurations, putRoadBookConfigurations,
} from '../../store/roadBookConfigurations/actions';
import withTranslation from '../../hoc/withTranslation';
import Error from '../../components/common/Error/Error';
import Loading from '../../components/common/Loading/Loading';
import styles from '../page/PagePage.css';
import AdminService, { ADMIN, SUPER_ADMIN } from '../../services/admin';
import { EDIT_ROAD_BOOK_CONFIGURATION_PAGE, ROAD_BOOKS_PAGE } from '../../constants/routes';
import style from '../../styles/styles';
import RoadBookConfigurationInfo from '../../components/roadbook/RoadBookConfigurationInfo';
import { getTrails } from '../../store/trails/actions';
import { getTypes } from '../../store/types/actions';
import { getCustomFields } from '../../store/customfields/actions';

const iconButtonElement = (
    <IconButton
        touch={true}
        tooltipPosition="bottom-left"
    >
        <MoreVertIcon color={grey400} />
    </IconButton>
);

export class RoadBookConfigurationPage extends React.Component {

    state = {
        roadBookConfiguration: null,
        openRemoveDialog: false,
        openDisableDialog: false,
    };

    componentWillMount() {
        this.fetchApplication();
        this.fetchRoadBookConfigurations();
        if (this.props.roadBookConfigurations) {
            const current = this.props.roadBookConfigurations[this.props.currentLang].find(rba =>
                rba.id === this.props.match.params.roadBookConfigurationId,
            );
            if (current) {
                this.setState({ roadBookConfiguration: current });
            }
        }
        if (this.props.app && this.props.trails[this.props.currentLang].length === 0) {
            this.props.getTrails(this.props.app, this.props.currentLang);
        }
        if (this.props.app && this.props.types.length === 0) {
            this.props.getTypes(this.props.app.id, this.props.currentLang);
        }
        if (this.props.app && !this.props.customFields) {
            this.props.getCustomFields(this.props.app.id);
        }
    }


    openRemoveDialog = () => {
        this.setState({ openRemoveDialog: true });
    }

    closeRemoveDialog = () => {
        this.setState({ openRemoveDialog: false });
    }

    openDisableDialog = () => {
        this.setState({ openDisableDialog: true });
    }

    closeDisableDialog = () => {
        this.setState({ openDisableDialog: false });
    }

    fetchRoadBookConfigurations(appId = null) {
        if (this.props.match) {
            let app = appId || this.props.match.params.appId;
            if (app && this.props.roadBookConfigurations === null) {
                const withDisabled = AdminService.isAuthorized(SUPER_ADMIN, this.props.user);
                this.props.getRoadBookConfigurations(app, this.props.currentLang, withDisabled);
            }
        }
    }

    fetchApplication(appId = null) {
        if (this.props.match) {
            const id = appId || this.props.match.params.appId;

            if (id) {
                this.props.fetchApp(id);
            }
        }
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.roadBookConfigurations && nextProps.roadBookConfigurations[nextProps.currentLang]) {
            const current = nextProps.roadBookConfigurations[nextProps.currentLang].find(rba =>
                rba.id === nextProps.match.params.roadBookConfigurationId,
            );
            if (current) {
                this.setState({ roadBookConfiguration: current });
            } else {
                //this.setState({ roadBookConfiguration: false });
                this.props.history.push(
                    ROAD_BOOKS_PAGE.replace(':appId', this.props.app.id)
                );
            }
        }
        if (
            nextProps.app
            && (
                !this.props.trails[nextProps.currentLang]
                || this.props.trails[nextProps.currentLang].length === 0
            )
        ) {
            nextProps.getTrails(nextProps.app, nextProps.currentLang);
        }

        if (
            nextProps.app
            && this.props.types.length === 0
        ) {
            nextProps.getTypes(nextProps.app.id, nextProps.currentLang);
        }
        if (nextProps.app && !this.props.customFields) {
            nextProps.getCustomFields(nextProps.app.id);
        }
        if (this.props.sending && !nextProps.sending) {
            this.closeRemoveDialog();
            this.closeDisableDialog();
        }
        if (this.props.deleting && !nextProps.deleting) {
            this.props.history.push(
                ROAD_BOOKS_PAGE.replace(':appId', this.props.app.id)
            );
        }
    }

    enableRoadBookConfiguration = () => {
        this.props.putRoadBookConfigurations(
            this.props.app.id,
            { id: this.state.roadBookConfiguration.id, is_activated: true },
            this.props.currentLang
        );
    }

    disableRoadBookConfiguration = () => {
        this.props.putRoadBookConfigurations(
            this.props.app.id,
            { id: this.state.roadBookConfiguration.id, is_activated: false },
            this.props.currentLang
        );
    }

    deleteRoadBookConfiguration = () => {
        this.props.deleteRoadBookConfigurations(
            this.props.app.id,
            this.state.roadBookConfiguration,
            this.props.currentLang
        );
    }

    renderDeleteDialog() {
        let actions = [
            <FlatButton
                label={this.props.t('generic.cancel')}
                disabled={this.props.loading}
                onClick={this.closeRemoveDialog}
            />,
            <FlatButton
                label={this.props.t('generic.delete')}
                primary={true}
                disabled={this.props.loading}
                onClick={this.deleteRoadBookConfiguration}
            />,
        ];
        return (
            <Dialog actions={actions}
                    title={this.props.t('module.road_book.delete_road_book_configuration_confirmation_title')}
                    modal={this.props.sending}
                    open={this.state.openRemoveDialog}
                    onRequestClose={this.handleCloseDeleteComment}
            >
                {this.props.sending && <Loading paper={false} />}
                {!this.props.sending &&
                    <p>
                        {this.props.t('module.road_book.delete_road_book_configuration_confirmation')}
                    </p>
                }
            </Dialog>
        );
    }

    renderDisableDialog() {
        let actions = [
            <FlatButton
                label={this.props.t('generic.cancel')}
                disabled={this.props.loading}
                onClick={this.closeDisableDialog}
            />,
            <FlatButton
                label={this.props.t('generic.disable')}
                primary={true}
                disabled={this.props.loading}
                onClick={this.disableRoadBookConfiguration}
            />,
        ];
        return (
            <Dialog actions={actions}
                    title={this.props.t('module.road_book.disable_road_book_configuration_confirmation_title')}
                    modal={this.props.sending}
                    open={this.state.openDisableDialog}
                    onRequestClose={this.closeDisableDialog}
            >
                {this.props.sending && <Loading paper={false} />}
                {!this.props.sending &&
                    <p>
                        {this.props.t('module.road_book.disable_road_book_configuration_confirmation')}
                    </p>
                }
            </Dialog>
        );
    }

    renderMenu() {
        let menu;
        const isAdmin = AdminService.isAuthorized(ADMIN, this.props.user);
        const isSuperAdmin = AdminService.isAuthorized(SUPER_ADMIN, this.props.user);
        if (isAdmin && this.state.roadBookConfiguration) {
            menu = (
                <IconMenu
                    style={styles.buttons}
                    iconButtonElement={iconButtonElement}
                    anchorOrigin={{
                        horizontal: 'right',
                        vertical: 'top',
                    }}
                    targetOrigin={{
                        horizontal: 'right',
                        vertical: 'top',
                    }}
                >
                    <Link
                        to={
                            EDIT_ROAD_BOOK_CONFIGURATION_PAGE
                                .replace(':appId', this.props.app.id)
                                .replace(':roadBookConfigurationId', this.state.roadBookConfiguration.id)
                        }
                    >
                        <MenuItem>
                            {this.props.t('generic.edit')}
                        </MenuItem>
                    </Link>
                    {this.state.roadBookConfiguration.is_activated
                        && <MenuItem onClick={this.openDisableDialog}>
                            {this.props.t('generic.disable')}
                        </MenuItem>
                    }
                    {isSuperAdmin && !this.state.roadBookConfiguration.is_activated
                        && <MenuItem onClick={this.enableRoadBookConfiguration}>
                            {this.props.t('generic.enable')}
                        </MenuItem>
                    }
                    {isSuperAdmin && !this.state.roadBookConfiguration.is_activated
                        && <MenuItem onClick={this.openRemoveDialog}>
                            {this.props.t('generic.remove')}
                        </MenuItem>
                    }
                </IconMenu>
            );
        }
        return menu;
    };

    renderInformation() {
        return (
            <div style={style.col} className="col-xs-12 col-sm-12 col-md-12">
                <RoadBookConfigurationInfo
                    roadBookConfiguration={this.state.roadBookConfiguration}
                    app={this.props.app}
                    lang={this.props.currentLang}
                    trail={
                        this.state.roadBookConfiguration
                        && this.state.roadBookConfiguration.trail_id
                        && this.props.trails[this.props.currentLang].find(trail =>
                            trail.id === this.state.roadBookConfiguration.trail_id,
                        )
                    }
                    hostingTypes={
                        this.props.types.length > 0
                        && this.state.roadBookConfiguration.hosting_types_id
                        && this.props.types.filter(type =>
                            this.state.roadBookConfiguration.hosting_types_id.includes(type.id),
                        )}
                    pointTypes={
                        this.props.types.length > 0
                        && this.state.roadBookConfiguration.point_types_id
                        && this.props.types.filter(type =>
                            this.state.roadBookConfiguration.point_types_id.includes(type.id),
                        )}
                    sortCustomField={
                        this.props.customFields
                        && this.state.roadBookConfiguration.sort_custom_field_id
                        && this.props.customFields.find(cf =>
                            cf.id === this.state.roadBookConfiguration.sort_custom_field_id,
                        )
                    }
                />
            </div>
        );
    }

    render() {
        if (this.props.error) {
            return (
                <Error
                    title={this.props.t('generic.error')}
                    subtitle={this.props.t('generic.error_loading')}
                    paper={true}
                />
            );
        } else if (this.props.loading || !this.props.app || this.state.roadBookConfiguration === null) {
            return <Loading paper={false} />;
        } else {
            return (
                <div style={styles.container}>
                    {this.renderMenu()}
                    <h3 style={style.navigation}>
                        {this.props.t('module.road_book.name')} / {this.props.t('generic.detail')} - {this.state.roadBookConfiguration.name}
                    </h3>
                    <div className="row">
                        {this.renderInformation()}
                    </div>
                    {this.renderDeleteDialog()}
                    {this.renderDisableDialog()}
                </div>
            );
        }
    }
}

function mapStateToProps(state) {
    return {
        currentLang: state.ui.currentLang,
        loading: state.apps.pending
            || state.roadBookConfigurations.pending
            || state.trails.pending
            || state.types.pending
            || state.customFields.pending,
        error: state.apps.error
            || state.roadBookConfigurations.error
            || state.trails.error
            || state.types.error
            || state.customFields.error,
        user: state.auth.content,
        app: state.apps.currentApplication,
        customFields: state.customFields.content,
        trails: state.trails.content,
        types: state.types.content,
        sending: state.roadBookConfigurations.sending,
        deleting: state.roadBookConfigurations.deleting,
        roadBookConfigurations: state.roadBookConfigurations.content,
    };
}

export default connect(mapStateToProps, {
    getTrails,
    getTypes,
    fetchApp,
    getCustomFields,
    getRoadBookConfigurations,
    putRoadBookConfigurations,
    deleteRoadBookConfigurations
})(withRouter(withTranslation(RoadBookConfigurationPage)));



// WEBPACK FOOTER //
// src/containers/roadbook/RoadBookAvailablePage.js